import { HELP_ARTICLES, type HelpArticle } from "@/lib/help-content";

const RECENT_KEY = "structura_food_help_recent_searches";
const MAX_RECENT = 8;

function normalize(s: string): string {
  return s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

function scoreArticle(article: HelpArticle, tokens: string[]): number {
  const title = normalize(article.title);
  const keywords = article.keywords.map(normalize);
  const body = normalize(article.content.slice(0, 500));
  let score = 0;
  for (const t of tokens) {
    if (!t) continue;
    if (title.includes(t)) score += 10;
    if (keywords.some((k) => k.includes(t))) score += 8;
    if (body.includes(t)) score += 2;
  }
  return score;
}

export function searchHelpArticlesRanked(query: string): HelpArticle[] {
  const q = query.trim();
  if (!q) return HELP_ARTICLES;
  const tokens = normalize(q).split(/\s+/).filter(Boolean);
  const scored = HELP_ARTICLES.map((a) => ({ a, s: scoreArticle(a, tokens) }))
    .filter((x) => x.s > 0)
    .sort((x, y) => y.s - x.s);
  if (scored.length) return scored.map((x) => x.a);
  return HELP_ARTICLES.filter((a) => {
    const haystack = normalize([a.title, a.section, ...a.keywords, a.content].join(" "));
    return tokens.every((t) => haystack.includes(t));
  });
}

export function loadRecentSearches(): string[] {
  if (typeof localStorage === "undefined") return [];
  try {
    return JSON.parse(localStorage.getItem(RECENT_KEY) ?? "[]") as string[];
  } catch {
    return [];
  }
}

export function pushRecentSearch(query: string): void {
  const q = query.trim();
  if (!q || typeof localStorage === "undefined") return;
  const prev = loadRecentSearches().filter((x) => x !== q);
  localStorage.setItem(RECENT_KEY, JSON.stringify([q, ...prev].slice(0, MAX_RECENT)));
}
